/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum StorefrontStatus {
  ACTIVE = 'active',
  ARCHIVED = 'archived',
}
